module.exports = __webpack_public_path__ + "media/images/athletes/2803-15209348b170967d0d51b2bad248a1a1.png";